// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/static/images/avatars/bg-3.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-box .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root .css-1d3z3hw-MuiOutlinedInput-notchedOutline .css-1in441m{
    height: 16px !important;
    color: grey !important;
}

.password-box .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root .css-1d3z3hw-MuiOutlinedInput-notchedOutline .css-1in441m  span{
    /* height: 40px !important; */
    color: blue !important;
    opacity: 1;
}

.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input:focus{
    /* color: #fff; */
}   

.css-1999axt-MuiAvatar-root{
    width: 202px !important;
    height: 89px !important;
    border-radius: 8px !important;
}

.logo-img{
    width: 200px !important;

}

.bg-image{
    height: 100%;
    width: 100%;
    object-fit: cover;
    position: relative;
    opacity: 0.5;
}

.Main-container-1{
    /* position: absolute;
    top: 0;
    left: 0;
    right: 0; */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}


.middle-section-container{
    background: #fff;
    padding: 50px;
    border-radius: 5px;

}

.css-binzgt{
    margin-top: 0 !important;
}
.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root{
    height: 61px !important; 
}

.css-1sumxir-MuiFormLabel-root-MuiInputLabel-root{
    color: #000 !important;
    font-size: 17px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Login/login.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;;;eAGW;IACX,yDAAuE;IACvE,4BAA4B;IAC5B,4BAA4B;IAC5B,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;;AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;;AAEtB;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B","sourcesContent":[".password-box .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root .css-1d3z3hw-MuiOutlinedInput-notchedOutline .css-1in441m{\n    height: 16px !important;\n    color: grey !important;\n}\n\n.password-box .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root .css-1d3z3hw-MuiOutlinedInput-notchedOutline .css-1in441m  span{\n    /* height: 40px !important; */\n    color: blue !important;\n    opacity: 1;\n}\n\n.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input:focus{\n    /* color: #fff; */\n}   \n\n.css-1999axt-MuiAvatar-root{\n    width: 202px !important;\n    height: 89px !important;\n    border-radius: 8px !important;\n}\n\n.logo-img{\n    width: 200px !important;\n\n}\n\n.bg-image{\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    position: relative;\n    opacity: 0.5;\n}\n\n.Main-container-1{\n    /* position: absolute;\n    top: 0;\n    left: 0;\n    right: 0; */\n    background-image: url('../../../public/static/images/avatars/bg-3.jpg');\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    background-size: cover;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n\n.middle-section-container{\n    background: #fff;\n    padding: 50px;\n    border-radius: 5px;\n\n}\n\n.css-binzgt{\n    margin-top: 0 !important;\n}\n.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root{\n    height: 61px !important; \n}\n\n.css-1sumxir-MuiFormLabel-root-MuiInputLabel-root{\n    color: #000 !important;\n    font-size: 17px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
